import { api, ApiError } from '../api.js';
import { bindSubmit, field, setStatus, statusZone } from '../components/form.js';
import { navigate } from '../router.js';

const STATUS_ID = 'reset-status';

export function renderResetPassword(root) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (!token) {
    root.innerHTML = `
      <div class="appbar"><div class="appbar-title">Reset password</div></div>
      <div class="pad">
        <div class="card">
          <p>This page needs a valid reset link from your email.</p>
          <p><a href="/forgot-password" data-link>Request a new link</a></p>
        </div>
      </div>
    `;
    return;
  }

  root.innerHTML = `
    <div class="appbar"><div class="appbar-title">Set a new password</div></div>
    <div class="pad">
      <form id="reset-form" class="form card" novalidate>
        ${field({
          name: 'new_password',
          label: 'New password',
          type: 'password',
          autocomplete: 'new-password',
          placeholder: 'min 8 chars, letter + digit',
        })}
        ${statusZone(STATUS_ID)}
        <button type="submit" class="btn">Update password</button>
      </form>
    </div>
  `;

  const form = document.getElementById('reset-form');
  bindSubmit(form, async (data) => {
    setStatus(STATUS_ID, { message: 'Updating…', kind: 'info' });
    try {
      await api('/auth/password/reset', {
        method: 'POST',
        body: { token, new_password: data.new_password },
      });
      setStatus(STATUS_ID, {
        message: 'Password updated. You can log in now.',
        kind: 'success',
      });
      setTimeout(() => navigate('/login'), 800);
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Could not update password.';
      setStatus(STATUS_ID, { message: msg, kind: 'error' });
    }
  });
}
